import React, {Component, PropTypes} from 'react';
import RequiredIndicator from './required-indicator';
import styleable from 'react-styleable';
import defaultStyle from './common.style.js';

export class RequiredLegend extends Component {
  render() {
    const { hasErrors, isRequired, content, css } = this.props;

    return(
      <legend className={css.requiredLegend} aria-label={content}>
        {hasErrors ? <span className={css.errorIndicator} aria-hidden='true'/> : null}
        {content}
        <RequiredIndicator css={css} isRequired={isRequired}/>
      </legend>
    );
  }
}

RequiredLegend.propTypes = {
  hasErrors: PropTypes.bool,
  content: PropTypes.string.isRequired,
  isRequired: PropTypes.bool.isRequired
};

export default styleable(defaultStyle) (RequiredLegend);



// WEBPACK FOOTER //
// src/common/required-legend.js